import React from 'react';
import { ProductCard } from './ProductCard';
const PRODUCTS = [{
  title: 'Sistema Profesional de Reiki Terapéutico',
  description: 'Formación, protocolos, símbolos, fichas y herramientas para sesiones Reiki más claras y organizadas.',
  image: 'https://cdn.magicpatterns.com/uploads/gXAyG1hLxXQ9Enx9i69gTa/ChatGPT_Image_3_jun_2026,_14_10_23.webp',
  link: 'https://guiareiki.codex-labs.shop'
}, {
  title: 'Programa Profesional de Constelación Familiar Terapéutica',
  description: 'Materiales, guías, cartas, preguntas y recursos para acompañar procesos terapéuticos con estructura.',
  image: 'https://cdn.magicpatterns.com/uploads/5pZBjhWYRFsWLuiiv65JdK/f6bcbe02-63e4-447b-bea0-f383f67f3f97.webp',
  link: 'https://constelacionfamiliar.codex-labs.shop'
}, {
  title: 'Tarot Terapéutico Profesional',
  description: 'Sistema de interpretación, tiradas, preguntas y herramientas para trabajar el tarot desde un enfoque terapéutico.',
  image: 'https://cdn.magicpatterns.com/uploads/dhirGgTQhSXSzqfB2vmwY2/ChatGPT_Image_3_jun_2026,_14_16_08.webp',
  link: 'https://tarot.codex-labs.shop'
}, {
  title: 'Kit Profesional de Radiestesia',
  description: 'Gráficos, protocolos, preguntas, ejercicios y herramientas prácticas para el trabajo con péndulo.',
  image: 'https://cdn.magicpatterns.com/uploads/g3sP3nwZz2qV1JDpPRCB6W/ChatGPT_Image_3_jun_2026,_14_13_47.webp',
  link: 'https://kitradiestesia.codex-labs.shop'
}];
export function ProductGrid() {
  return <section id="programas" className="py-24 px-4 bg-beige/30 pt-[0px] pb-[50px]" data-id="element-61">
      <div className="max-w-6xl mx-auto" data-id="element-62">
        <div className="text-center mb-16 space-y-4" data-id="element-63">
          <h2 className="text-4xl md:text-5xl font-bold text-text-dark" data-id="element-64">
            Nuestros Programas
          </h2>
          <div className="w-24 h-1 bg-gold/30 mx-auto rounded-full" data-id="element-65" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-66">
          {PRODUCTS.map((product, index) => <ProductCard key={index} index={index} {...product} data-id="element-67" />)}
        </div>
      </div>
    </section>;
}